import { command, isFunction } from "../../../../shared/utils.js";
import wifiCfg from "../../../../settings/wifiCfg.js";
import fileSys from "../../../../fileoprators/fileSystem.js";
// import wpaSocket from './wpaSocket.js'

const EventEmitter = window.require("events");
const { exec, execSync } = window.require("child_process");
const fs = window.require("fs");
let unixdgram = {};
let _socket;
if (!window.__main__.debug) {
  unixdgram = window.require("unix-dgram");
}

const wlnname = fileSys.detectWirelessCard();
let socketpath;
async function wait(ms) {
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve();
    }, ms);
  });
}

async function setNetworkManual(settings) {
  return new Promise((resolve, reject) => {
    exec(
      command(`ifconfig ${wlnname} ${settings.ip} netmask ${settings.netmask}`),
      (err, stdout, stderr) => {
        if (err) {
          console.log("Set network failed.", err);
          reject(new Error("Set ip failed"));
        } else {
          exec(command(`route del default dev ${wlnname}`), (err, stdout, stderr) => {
            if (err) {
              console.log("Set gateway failed (del).", err);
            }
            if (settings.gateway && settings.dns) {
              exec(
                command(`route add default gw ${settings.gateway} dev ${wlnname}`),
                (err, stdout, stderr) => {
                  if (err) {
                    console.log("Set gateway failed (add).", err);
                    reject(new Error("Add gateway failed"));
                  } else {
                    exec(
                      command(`echo -n "nameserver ${settings.dns}" > /etc/resolv.conf`),
                      (err, stdout, stderr) => {
                        if (err) {
                          console.log("Set dns failed.", err);
                          reject(new Error("Set DNS failed"));
                        } else {
                          resolve(settings);
                        }
                      }
                    );
                  }
                }
              );
            } else {
              resolve(settings);
            }
          });
        }
      }
    );
  });
}

async function dhcpLease(times) {
  // /etc/udhcpc.d/50default 文件需要修改。
  return new Promise((resolve, reject) => {
    let t = typeof times === "number" ? (times <= 8 && times > 0 ? times : 8) : 8;
    exec(fileSys.getUtilPath("dhcp.sh"), (e, out, err) => {
      console.log(fileSys.getUtilPath("dhcp.sh"), e, out, err);
      if (err) {
        console.log(err.code);
        reject(new Error(`No lease:${err.code}`));
      } else {
        resolve();
      }
    });
    // exec(command(`dhclient -r ${wlnname}`), (e, out, stderrR) => {
    //   console.log(`dhclient -r ${wlnname}`, e, out, stderrR)
    //   exec(command(`dhclient -v ${wlnname}`), (err, stdout, stderr) => {
    //     console.log(`dhclient ${wlnname}`, stdout, err, stderr)
    //     if (err) {
    //       console.log(err.code)
    //       reject(new Error(`No lease:${err.code}`))
    //     } else {
    //       resolve()
    //     }
    //   })
    // })
  });
}

// function wpaCtrlSocketInit (ctrlEvtCb) {
//   let s = {socket: undefined, path: undefined, evtcb: undefined}
//   s.socket = unixdgram.createSocket('unix_dgram', function (buf) {
//     // console.log(`msg:${buf}`)
//     // cb(buf.toString())
//     setTimeout(() => {
//       console.log(`wpamsg:${buf}`)
//       let bufres = buf.toString()
//       if (bufres.indexOf('<3>') >= 0 && isFunction(ctrlEvtCb)) {
//         ctrlEvtCb(bufres)
//       } else {
//         if (isFunction(s.evtcb)) {
//           s.evtcb(bufres)
//         }
//       }
//     }, 10)
//   })
//   for (let cnt = 0; cnt < 256; cnt++) {
//     try {
//       console.log(
//         'process.pid',
//         '/tmp/wpa_ctrl_' + window.process.pid + '-' + cnt
//       )
//       s.socket.bind('/tmp/wpa_ctrl_' + window.process.pid + '-' + cnt)
//       s.path = socketpath = '/tmp/wpa_ctrl_' + window.process.pid + '-' + cnt
//       break
//     } catch (e) {
//       console.log('wpaCtrlSocketInit', e)
//       s.socket.close()
//       if (s.path) {
//         fileSys.unlinkSync(s.path)
//       }
//       throw e
//     }
//   }
//   try {
//     s.socket.connect(WPACTRLINTERFACE)
//   } catch (e) {
//     console.log('connect', e)
//     wificonnectErr(e)
//   }
//   setTimeout(() => {
//     socket.send(Buffer.from('ATTACH'))
//   }, 500)
//   return socket
// }
function wpaCtrlSocketInit(cb) {
  let socket = unixdgram.createSocket("unix_dgram", function (buf) {
    // console.log(`msg:${buf}`)
    cb(buf.toString());
  });
  for (let cnt = 0; cnt < 256; cnt++) {
    try {
      socket.bind("/tmp/wpa_ctrl_" + window.process.pid + "-" + cnt);
      socketpath = "/tmp/wpa_ctrl_" + window.process.pid + "-" + cnt;
      break;
    } catch (e) {}
  }
  try {
    socket.connect(WPACTRLINTERFACE);
  } catch (e) {
    wificonnectErr(e);
  }
  setTimeout(() => {
    socket.send(Buffer.from("ATTACH"));
  }, 500);
  return socket;
}

async function wpaCtrlRequest(wpactrl, cmd) {
  // console.log(cmd)
  return new Promise((resolve, reject) => {
    let timer = setTimeout(() => {
      wpactrl.socketcb = undefined;
      reject(new Error("time out."));
    }, 1000 * 8);
    wpactrl.socketcb = (buf) => {
      clearTimeout(timer);
      wpactrl.socketcb = undefined;
      resolve(buf.toString());
    };
    wpactrl.socket.send(window.Buffer.from(cmd));
  });
}
const wifiError = {
  ServiceError: "send -2",
  connectError: "connect -111",
  wifiService: "connect -2"
};
const selectWifiError = (str) => {
  const vals = Object.values(wifiError);
  const keys = Object.keys(wifiError);
  for (let index = 0; index < vals.length; index++) {
    const element = vals[index];
    if (element.indexOf(str) > -1) {
      return keys[index];
    }
  }
};
async function wificonnectErr(e) {
  const key = e.message;
  console.error("wificonnectErr", e.message);
  const errorKeys = Object.keys(wifiError);
  const errorMessage = selectWifiError(key);
  console.log("errorMessage", errorMessage);
  try {
    switch (errorMessage) {
      case errorKeys[0]:
        execSync(fileSys.getUtilPath("wifi.sh"));

        break;
      case errorKeys[1]:
        execSync(fileSys.getUtilPath("wifi.sh"));

        break;
      case errorKeys[2]:
        execSync(fileSys.getUtilPath("wifi.sh"));

        break;
      default:
        // TODO 报错
        execSync(fileSys.getUtilPath("wifi.sh"));

        break;
    }
  } catch (error) {
    console.error("wificonnectErr", error, errorMessage);
  }
}

const WPACTRLINTERFACE = `/var/run/wpa_supplicant/${wlnname}`;
const WPA_CMD = {
  listInterfaces: "ifconfig",
  attach: "ATTACH",
  scan: "SCAN",
  scanResult: "SCAN_RESULTS",
  addNetwork: "ADD_NETWORK",
  listNetwork: "LIST_NETWORKS",
  setSSID: 'SET_NETWORK :id ssid ":ssid"',
  setPassword: 'SET_NETWORK :id psk ":password"',
  setNetwork: "SET_NETWORK :id :key :value",
  setScanSsid: "SET_NETWORK :id scan_ssid 1",
  removeNetwork: "REMOVE_NETWORK :id",
  wpsCancel: "WPS_CANCEL",
  status: "STATUS",
  enableNetwork: "ENABLE_NETWORK :id",
  disableNetwork: "DISABLE_NETWORK :id",
  selectNetwork: "SELECT_NETWORK :id",
  disconnectAP: "DISCONNECT",
  peerSearch: "P2P_FIND",
  peerStopSearch: "P2P_STOP_FIND",
  peerConnect: "P2P_CONNECT :peer_addr :auth_type :pin :owner_params",
  peerInfo: "P2P_PEER :peer_addr",
  peerInvite: "P2P_INVITE",
  removeVirtIface: "P2P_GROUP_REMOVE :iface",
  flushPeers: "P2P_FLUSH"
};

const WSTAT_IDLE = 0;
const WSTAT_CONNECTING = 1;
const WSTAT_CONNECTING2 = 2;
const WSTAT_CONNECT_FAILED = 3;
const WSTAT_CONNECT_COMPLETE = 4;
const WSTAT_CONNECT_WRONGKEY = 5;
const WSTAT_SCANNING = 6;
const WSTAT_SCAN_COMPLETE = 7;
const WSTAT_SCAN_FAILED = 8;
const WSTAT_DISABLED = 9;
const WSTAT_ENABLING = 10;
const WSTAT_DISABLING = 11;
/** WPA WIFI控制类.
 * @param {string} ctrlpath 控制器接口路径
 */
class WPACtrl extends EventEmitter {
  constructor() {
    super();
    this.initWpa()
      .then()
      .catch((err) => {
        console.log("WPACtrlconstructor", err);
      });
  }
  socketInit() {
    this.socketcb = undefined;
    let _self = this;
    return new Promise((resolve, reject) => {
      _self.socket = wpaCtrlSocketInit((buf) => {
        let bufres = buf.toString();
        if (_self.socketcb && bufres.indexOf("<3>") < 0) {
          _self.socketcb(buf);
          _self.socketcb = undefined;
        }
        _self._onMsg(buf);
        resolve();
      });
    });
  }
  enable() {
    let _self = this;
    return new Promise((resolve, reject) => {
      if (_self.connStatus !== WSTAT_DISABLED) {
        resolve();
      } else {
        _self.connStatus = WSTAT_ENABLING;
        exec(command(_self.wpaOn), async (error, stdout, stderr) => {
          if (error) {
            console.log(command(_self.wpaOn), error);
          }
          _self.wificfg = _self.readCfg();
          await _self.socketInit();
          _self.connStatus = WSTAT_IDLE;

          if (_self.wificfg.enabled) {
            setTimeout(() => {
              _self
                .connect(_self.wificfg)
                .then(() => {
                  resolve();
                })
                .catch(() => {
                  _self
                    .connect(_self.wificfg)
                    .then(() => {
                      resolve();
                    })
                    .catch(() => {
                      resolve();
                    });
                });
            }, 1000 * 2);
          } else {
            resolve();
          }
        });
      }
    });
  }

  async disable() {
    let _self = this;
    return new Promise((resolve, reject) => {
      if (_self.connStatus === WSTAT_DISABLING || _self.connStatus === WSTAT_DISABLED) {
        resolve();
      } else {
        _self.connStatus = WSTAT_DISABLING;
        exec(command(_self.wpaOff), (error, stdout, stderr) => {
          _self.connStatus = WSTAT_DISABLED;
          if (error) {
            reject(error);
          } else {
            resolve();
          }
        });
        _self.disableSocket();
      }
    });
  }
  disableSocket() {
    if (this.socket) {
      this.socket.close();
      fs.unlinkSync(socketpath);
      this.socket = undefined;
    }
  }
  get connStatus() {
    return this._connStatus;
  }

  set connStatus(connStatus) {
    if (this.connStatus === WSTAT_CONNECTING && connStatus === WSTAT_CONNECT_FAILED) {
      this.removeNetwork();
    }
    this._connStatus = connStatus;
    return this._connStatus;
  }

  async initWpa() {
    this.scanlist = {};
    this.timeoutID = "";
    // sudo killall wpa_supplicant
    // sudo wpa_supplicant -i wlp2s0 -B -c /home/mw520/wpa_supplicant.conf
    this.wpaOn = `wpa_supplicant -i ${wlnname} -B -c /home/mw520/wpa_supplicant.conf`;
    this.wpaOff = "killall wpa_supplicant";
    this.wificfg = this.readCfg();
    this._connStatus = WSTAT_DISABLED;
    this.scanStatus = WSTAT_IDLE;
    this.socketInit();
    // this.connStatus = WSTAT_IDLE
    try {
      await this.enable();
    } catch (e) {}
  }
  readCfg() {
    try {
      let wifiCfg = window.wifiCfg;
      return wifiCfg;
    } catch (e) {
      return {
        ssid: "",
        psk: "",
        enabled: false,
        mode: "auto"
      };
    }
  }
  saveCfg(cfg) {
    try {
      wifiCfg.saveWifiSettings(cfg);
    } catch (e) {
      console.log("save cfg error:", e);
    }
  }
  _onScanResult(msg) {
    msg = msg.split("\n");
    msg.splice(0, 1);
    let scanResults = {};
    msg.forEach(function (line) {
      if (line.length > 3) {
        line = line.split("\t");
        let bssid = line[0].trim();
        scanResults[bssid] = {
          bssid: line[0].trim(),
          freq: line[1].trim(),
          rssi: line[2].trim(),
          flag: line[3].trim(),
          ssid: line[4].trim()
        };
      }
    });
    // console.log(scanResults)
    this.emit("scan_results", scanResults);
  }
  _onListNetwork(msg) {
    msg = msg.split("\n");
    msg.splice(0, 1);
    var networkResults = [];
    msg.forEach(function (line) {
      if (line.length > 3) {
        line = line.split("\t");
        networkResults.push({
          networkId: line[0].trim(),
          ssid: line[1].trim()
        });
      }
    });
    // console.log(networkResults)
    this.emit("list_network", networkResults);
  }
  _onCtrlEvent(msg) {
    switch (true) {
      case /CTRL-EVENT-SCAN-STARTED/.test(msg):
        // console.log('scanning')
        // this.emit('scanning');
        break;
      case /CTRL-EVENT-SCAN-RESULTS/.test(msg):
        // this._onScanResult(msg);
        // this.emit('scan_complete')
        break;
      case /CTRL-EVENT-CONNECTED/.test(msg):
        // this._onApConnected(msg);
        this.emit("ap_connected");
        break;
      case /CTRL-EVENT-DISCONNECTED/.test(msg):
        this.emit("ap_disconnected");
        break;
      case /CTRL-EVENT-NETWORK-NOT-FOUND/.test(msg):
        this.emit("ap_disconnected");
        break;
    }
  }
  _onStatus(msg) {
    msg = msg.split("\n");
    var status = {};
    msg.forEach(function (line) {
      if (line.length > 3) {
        line = line.split("=");
        status[line[0]] = line[1];
      }
    });
    this.emit("status", status);
  }
  parseListNetwork(msg) {
    msg = msg.split("\n");
    msg.splice(0, 1);
    var networkResults = [];
    msg.forEach(function (line) {
      if (line.length > 3) {
        line = line.split("\t");
        networkResults.push({
          networkId: line[0].trim(),
          ssid: line[1].trim()
        });
      }
    });
    // console.log(networkResults)
    return networkResults;
  }
  parseScanResult(msg) {
    msg = msg.split("\n");
    msg.splice(0, 1);
    let scanResults = {};
    msg.forEach(function (line) {
      if (line.length > 3) {
        line = line.split("\t");
        let bssid = line[0].trim();
        scanResults[bssid] = {
          bssid: line[0].trim(),
          freq: line[1].trim(),
          rssi: line[2].trim(),
          flag: line[3].trim(),
          ssid: line[4].trim()
        };
      }
    });
    return scanResults;
  }
  parseStatus(msg) {
    msg = msg.split("\n");
    var status = {};
    msg.forEach(function (line) {
      if (line.length > 3 && line.indexOf("=") >= 0) {
        line = line.split("=");
        status[line[0]] = line[1];
      }
    });
    return status;
  }
  _onMsg(msg) {
    switch (true) {
      case /<3>/.test(msg):
        this._onCtrlEvent(msg.toString());
        break;
      case /bssid \/ frequency \/ signal level \/ flags \/ ssid/.test(msg):
        this._onScanResult(msg);
        break;
      case /network id \/ ssid \/ bssid \/ flags/.test(msg):
        this._onListNetwork(msg);
        break;
      // eslint-disable-next-line no-useless-escape
      case /p2p_device_address\=\w{2}\:\w{2}\:\w{2}\:\w{2}\:\w{2}\:\w{2}\naddress\=\w/.test(msg):
        this._onStatus(msg);
        break;
      // eslint-disable-next-line no-useless-escape
      case /\w{2}\:\w{2}\:\w{2}\:\w{2}\:\w{2}\:\w{2}\npri_dev_type\=\w/.test(msg):
        this._onPeerInfo(msg);
        break;
    }
  }

  async Request(cmd) {
    if (this.connStatus === WSTAT_DISABLED) {
      return "Failed";
    }

    let res;
    // console.log('================ wait prev cmd:', cmd)
    for (let i = 0; i < 100; i++) {
      if (this.socketcb !== undefined) {
        await wait(100);
        if (i >= 99) {
          return "Failed";
        }
      } else {
        break;
      }
    }
    // console.log('================ send cmd', cmd)
    try {
      res = await wpaCtrlRequest(this, cmd);
    } catch (e) {
      return "Failed";
    }
    // console.log('================== Request Res:', res, cmd)
    return res.toString();
  }

  async status() {
    if (this.statusCache !== undefined) {
      return this.statusCache;
    } else {
      let res = await this.Request(WPA_CMD.status);
      let status = this.parseStatus(res);
      this.statusCache = status;
      let _self = this;
      setTimeout(() => {
        _self.statusCache = undefined;
      }, 5000);
      return status;
    }
  }
  async getNetworks() {
    let res = await this.Request(WPA_CMD.listNetwork);
    let networks = this.parseListNetwork(res.toString());
    // console.log(networks)
    return networks;
  }
  async scan() {
    let res = await this.Request(WPA_CMD.scanResult);
    let aplist = this.parseScanResult(res.toString());
    if (this.scanCache === undefined) {
      for (let i = 0; i < 3; i++) {
        let scanres = await this.Request(WPA_CMD.scan);
        // console.log(scanres)
        if (scanres.indexOf("OK") >= 0) {
          this.scanCache = true;
          let _self = this;
          setTimeout(() => {
            _self.scanCache = undefined;
          }, 10000);
          break;
        }
      }
    }
    return aplist;
  }

  async removeNetwork() {
    this.removeAllListeners("ap_disconnected");
    this.removeAllListeners("ap_connected");
    let networks = await this.getNetworks();

    for (let i in networks) {
      await this.Request(WPA_CMD.removeNetwork.replace(":id", networks[i].networkId));
      await wait(1000);
    }
    await this.Request(WPA_CMD.wpsCancel);
    await await 1000;
  }
  /**
   * 断开当前的WIFI连接
   * @param {Boolean} forget 如需遗忘此链接，设置为true
   */
  async disconnect(forget) {
    let networks = await this.getNetworks();

    for (let i in networks) {
      // console.log('remove saved network', i)
      await this.Request(WPA_CMD.removeNetwork.replace(":id", networks[i].networkId));
    }
    try {
      await dhcpLease(8);
    } catch (e) {}
    if (forget) {
      this.wificfg.enabled = false;
      this.saveCfg(this.wificfg);
    }
    this.connStatus = WSTAT_IDLE;
    return this.connStatus;
  }

  /**
   * 连接热点
   * @param {object} cfg - 包含连接信息的对象，格式如下：
   * ```
   *                  {
   *                     ssid: 'XXXSSID', // SSID
   *                     psk: 'password', // 如连接的热点无密码，则无需此项
   *                     enabled: true,   // 是否启用此wifi
   *                     mode: 'auto',    // 或者 'manual'，如是manual 需要提供下面的settings
   *                     settings: {
   *                       ip: 'xxx.xxx.xxx.xxx',
   *                       netmask: 'xxx.xxx.xxx.xxx',
   *                       gateway: 'xxx.xxx.xxx.xxx',
   *                       dns: 'xxx.xxx.xxx.xxx'
   *                     }
   *                  }
   * ```
   * @param {connectCallback} callback - 连接完成后的回调
   */
  async waitConnectResult() {
    let _self = this;
    return new Promise((resolve, reject) => {
      let timeoutID = setTimeout(() => {
        _self.removeAllListeners("ap_disconnected");
        _self.removeAllListeners("ap_connected");
        reject(new Error("connect timeout."));
      }, 20000);
      _self.once("ap_disconnected", () => {
        _self.removeAllListeners("ap_disconnected");
        _self.removeAllListeners("ap_connected");
        clearTimeout(timeoutID);
        reject(new Error("connect failed."));
      });
      _self.once("ap_connected", () => {
        _self.removeAllListeners("ap_disconnected");
        _self.removeAllListeners("ap_connected");
        clearTimeout(timeoutID);
        resolve();
      });
    });
  }

  async connect(cfg, hasHide = false) {
    if (this.connStatus === WSTAT_CONNECTING) {
      throw new Error("already connecting");
    }

    this.connStatus = WSTAT_CONNECTING;
    // ============ 清除已连接的网络 =================
    const isManual = cfg.mode !== "auto" && cfg.settings;
    if (!isManual) {
      await this.removeNetwork();
    }
    // ============ 添加网络 =================
    let netid = (await this.Request(WPA_CMD.addNetwork)).split("\n")[0].trim();

    // ============ 设置SSID与密码 =================
    let res = await this.Request(WPA_CMD.setSSID.replace(":id", netid).replace(/:ssid/, cfg.ssid));

    if (res.indexOf("OK") < 0) {
      await this.Request(WPA_CMD.removeNetwork.replace(":id", netid));
      this.connStatus = WSTAT_CONNECT_FAILED;
      throw new Error("set ssid failed");
    }

    if (cfg.psk) {
      res = await this.Request(
        WPA_CMD.setPassword.replace(":id", netid).replace(/:password/, cfg.psk)
      );

      if (res.indexOf("OK") < 0) {
        await this.Request(WPA_CMD.removeNetwork.replace(":id", netid));
        this.connStatus = WSTAT_CONNECT_FAILED;
        throw new Error("set psk failed");
      }
    }

    if (hasHide) {
      await this.Request(WPA_CMD.setScanSsid.replace(":id", netid));
    }

    // ============ 启用网络 =================
    res = await this.Request(WPA_CMD.selectNetwork.replace(":id", netid));

    // ============ 等待连接结果 =================
    if (!isManual) {
      try {
        await this.waitConnectResult();
      } catch (e) {
        await this.Request(WPA_CMD.removeNetwork.replace(":id", netid));
        this.connStatus = WSTAT_CONNECT_FAILED;
        throw e;
      }
    }

    if (cfg.mode === "auto") {
      // ============ DHCP自动设置 =================
      for (let i = 0; i < 3; i++) {
        try {
          await dhcpLease(18);
          break;
        } catch (e) {
          // ============ 分配地址错误则重新连接一下网络再重试 =================
          await this.Request(WPA_CMD.disableNetwork.replace(":id", netid));
          await this.Request(WPA_CMD.enableNetwork.replace(":id", netid));
          if (i >= 2) {
            await this.Request(WPA_CMD.removeNetwork.replace(":id", netid));
            this.connStatus = WSTAT_CONNECT_FAILED;
            throw e;
          }
        }
      }
    } else {
      // ============ 手动设置 =================
      if (cfg.settings) {
        try {
          setNetworkManual(cfg.settings);
          await this.Request(WPA_CMD.disableNetwork.replace(":id", netid));
          await this.Request(WPA_CMD.enableNetwork.replace(":id", netid));
        } catch (e) {
          this.connStatus = WSTAT_CONNECT_FAILED;
          throw e;
        }
      } else {
        this.connStatus = WSTAT_CONNECT_FAILED;
        throw new Error("no settings");
      }
    }
    cfg.enabled = true;
    this.saveCfg(cfg);
    this.connStatus = WSTAT_CONNECT_COMPLETE;
  }

  getConnStatus() {
    return this.connStatus;
  }

  static init() {
    if (!window.__main__.debug) {
      this.WPACtrl = this.WPACtrl || new WPACtrl();
    } else {
      this.WPACtrl = {};
    }
    return this.WPACtrl;
  }
  static reset() {
    this.WPACtrl = new WPACtrl();
  }
}
// module.exports = WPACtrl.init()
export default WPACtrl.init();



// WEBPACK FOOTER //
// ./src/mainInterface/js/wifi/wpa_wifi/wpaWIfi.js